import React, { useContext, useEffect } from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";

const ComplianceView = (props) => {
  const { cycles } = useContext(CycleFilterContext);
  const { viewModel, dispatch } = useContext(OverviewContext);

  const getComplianceData = () => {
    dispatch({
      type: "LOAD_COMPLIANCE_OVERVIEW",
      data: {
        filter: cycles.selectedCycles,
        dispatcher: dispatch,
        processName: props.compliance.processName,
      },
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getComplianceData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getComplianceData();
        }
      }, props.compliance.refreshRate);
      return () => clearInterval(interval);
    }
  }, [cycles]);

  return (
    <div>
      <div className="overview-fph">
        <Heading level={3} type="h300" alignment="left">
          <Tooltip
            position="right"
            title={props.intl.formatMessage({
              id: viewModel.compliance[props.compliance.processName].tooltip,
              defaultMessage:
                viewModel.compliance[props.compliance.processName]
                  .tooltipMessage,
            })}
          >
            <FormattedMessage
              id={viewModel.compliance[props.compliance.processName].title}
              defaultMessage={
                viewModel.compliance[props.compliance.processName]
                  .defaultMessage
              }
            />
          </Tooltip>
        </Heading>
      </div>

      <Text type="d50">
        {props.compliance.processName === "rolledVolume"
          ? viewModel.compliance[props.compliance.processName].value > 0
            ? viewModel.compliance[props.compliance.processName].value
            : "0" +
              " " +
              viewModel.compliance[props.compliance.processName].prefixValue
          : ""}
        {props.compliance.processName === "shiftPace"
          ? isFinite(
              viewModel.compliance.rolledVolume.value /
                viewModel.fph.sort.actual,
            )
            ? viewModel.compliance.rolledVolume.value /
                viewModel.fph.sort.actual >
              0
              ? Math.abs(
                  Math.round(
                    (viewModel.compliance.rolledVolume.value /
                      viewModel.fph.sort.actual) *
                      60,
                  ),
                ) > 120
                ? 120
                : Math.abs(
                    Math.round(
                      (viewModel.compliance.rolledVolume.value /
                        viewModel.fph.sort.actual) *
                        60,
                    ),
                  ) + "mins behind"
              : Math.abs(
                    Math.round(
                      viewModel.compliance.rolledVolume.value /
                        viewModel.fph.sort.actual,
                    ) * 60,
                  ) > 120
                ? 120
                : Math.abs(
                    Math.round(
                      viewModel.compliance.rolledVolume.value /
                        viewModel.fph.sort.actual,
                    ) * 60,
                  ) + "mins above"
            : "0mins behind"
          : ""}
        {props.compliance.processName === "goldilock" ||
        props.compliance.processName === "scanCompliance"
          ? viewModel.compliance[props.compliance.processName].value +
            viewModel.compliance[props.compliance.processName].prefixValue
          : ""}
      </Text>
    </div>
  );
};

export default injectIntl(ComplianceView);



// WEBPACK FOOTER //
// ./src/components/complaince/complianceView.js